import Immutable from 'immutable';
import reframe, { parametric, subscription } from 'nike-re-framejs';
import { denormalizeTournamentId } from '@/nikeone/domain/sportevent';
import { nike1Bet$, nike1SportEvent$ } from '@/nikeone/subs';
import { localizeMap } from 'nike-ui/src/components/turboLive/utils';
import { mainBet$$ } from 'nike-ui/src/components/turboLive/push/overview/hybrid-subs';
import { match$$ } from 'nike-ui/src/components/turboLive/push/overview/subs';

reframe.regSub(
    'sub:p::nikeone.live.event.options-info',
    ([_, eventId]) => [reframe.subscribe(['sub::nikeone.live.event', eventId])],
    ([event]) => {
        if (!event) {
            return null;
        }
        const match = event.get('match');
        const mainBet = event.getIn(['bets', match.get('mainBettingEventId')]) || Immutable.Map();
        return {
            betNumber: mainBet.get('id'),
            betName: mainBet.get('name'),
            tournamentNote: null,
            eventId: match.get('id'),
            sportName: match.get('sportName'),
            tournamentId: match.get('tournamentId'),
            tournamentName: match.get('tournamentName'),
            opponents: [match.getIn(['opponents', 'home']), match.getIn(['opponents', 'away'])].filter(Boolean),
            start: match.get('start'),
            type: 'LIVE'
        };
    }
);

export const nike1LiveEventOptionsInfo$ = parametric(eventId =>
    subscription(
        (event, bet, liveMatch) => {
            if (!event) {
                return null;
            }
            return {
                betNumber: bet?.get('id'),
                betName: localizeMap(bet?.get('header')),
                tournamentNote: bet?.get('tournamentNote'),
                eventId: event.get('sportEventId'),
                sportName: event.get('sportName'),
                tournamentId: denormalizeTournamentId(event.get('tournamentId')),
                tournamentName: event.get('tournamentName'),
                opponents: event.get('participants').toArray(),
                start: liveMatch.get('startTime'),
                type: 'LIVE'
            };
        },
        nike1SportEvent$('filteredBoxStore', eventId),
        mainBet$$(eventId),
        match$$(null, eventId)
    )
);

export const nike1PrematchEventOptionsInfo$ = parametric((boxStore, eventId, betId) =>
    subscription(
        (event, bet) => {
            if (!event || !event.size) {
                return null;
            }
            const mainBet = bet || Immutable.Map();
            return {
                betId: mainBet.get('betId'),
                betNumber: mainBet.get('betNumber'),
                betName: mainBet.get('header'),
                tournamentNote: mainBet.get('tournamentNote'),
                eventId: event.get('sportEventId'),
                sportName: event.get('sportName'),
                tournamentId: denormalizeTournamentId(event.get('tournamentId')),
                tournamentName: event.get('tournamentName'),
                opponents: event.get('participants').toArray(),
                start: event.get('expiration'),
                type: mainBet.get('bettingState') === 'FINISHED' ? 'RESULTS' : 'PREMATCH'
            };
        },
        nike1SportEvent$(boxStore, eventId),
        nike1Bet$(boxStore, betId)
    )
);
